import { FormCadProps, FormCad } from "./formCad";


export default function ViewForm(form: FormCadProps) {
    return (
        <FormCad
            contentForm={form.contentForm}
            row={form.row}
            handleMutator={form.handleMutator}
            handleOnSubmit={form.handleOnSubmit}
            handleCancel={form.handleCancel}
            buttonActions={form.buttonActions}
            ContentBox={form.ContentBox}
            formValidation={form.formValidation}
            mutators={form.mutators}
        />
    )
}